import { Middleware } from '@reduxjs/toolkit';
import events from '../events';

const triggerActionMiddleware: Middleware = () => next => (action) => {
    next(action);
    events.emit(action.type, action);
};

export default triggerActionMiddleware;
